import legal_nlNL from "./legal_nlNL";
import scriptie_nlNL from "./scriptie_nlNL";
import medical_enUS from "./medical_enUS";
import coa_generic_enUS from "./coa_generic_enUS";
import default_enUS from './default_enUS';
import unity_enUS from "./unity_enUS";
import engineer_enUS from "./engineer_enUS";
import engineer_v2_enUS from "./engineer_v2_enUS";
import toolkevin from "./toolkevin";

export const roles = {
    [legal_nlNL.key]: legal_nlNL,
    [scriptie_nlNL.key]: scriptie_nlNL,
    [medical_enUS.key]: medical_enUS,
    [coa_generic_enUS.key]: coa_generic_enUS,
    [unity_enUS.key]: unity_enUS,
    [default_enUS.key]: default_enUS,
    [engineer_enUS.key]: engineer_enUS,
    [engineer_v2_enUS.key]: engineer_v2_enUS,
    [toolkevin.key]: toolkevin,
};

export const defaultRole = engineer_v2_enUS.key;
